import { DirectiveBinding, Directive } from 'vue';

interface ClickOutsideElement extends HTMLElement {
  __vueClickEventHandler__: EventListenerOrEventListenerObject
}

export default {
  beforeMount(el: ClickOutsideElement, binding: DirectiveBinding) {
    // Define Handler and cache it on the element
    const { bubble } = binding.modifiers;
    const ourClickEventHandler: EventListenerOrEventListenerObject = (e) => {
      if (bubble || (!el.contains(e.target as HTMLElement) && el !== e.target)) {
        binding.value.handler(e);
      }
    };

    // eslint-disable-next-line no-param-reassign
    el.__vueClickEventHandler__ = ourClickEventHandler;
    // add Event Listeners
    document.addEventListener('click', ourClickEventHandler);
  },
  unmounted(el: ClickOutsideElement) {
    document.removeEventListener('click', el.__vueClickEventHandler__);
  },
} as Directive;
